(function() {
	'use strict';

	angular.module('claimsApp').controller('ClaimRegistrationGAMCancelDialogController',
			ClaimRegistrationGAMCancelDialogController);

	ClaimRegistrationGAMCancelDialogController.$inject = [ '$scope', '$state', '$log','ClaimRegistration','$stateParams','claimCase','$uibModalInstance' ];

	function ClaimRegistrationGAMCancelDialogController($scope, $state, $log,ClaimRegistration,$stateParams,claimCase,$uibModalInstance) {
		var param = $stateParams;
		
		var claimCancelDialogCtrl = this;
		
		ClaimRegistration.getReasonCancel({},function(result){
			claimCancelDialogCtrl.reasons = result;
		});
		
		claimCancelDialogCtrl.cancel = function() {
	    	    $uibModalInstance.dismiss('cancel');
	    };
	    
	    claimCancelDialogCtrl.submit = function (){
	    	var data = {
	    		cancelCode:claimCancelDialogCtrl.cancelCode,
	    		taskInstanceId:claimCase.taskInstanceId,
	    		claimCaseId: claimCase.claimCaseId,
	    		txnId:claimCase.txnId
	    	}
	    	ClaimRegistration.cancelCase(data,function(result){
	    		 $uibModalInstance.close(claimCase);
	    	});
	    }
	}
})();
